const EMAIL_PATTERN = /^(\S)+@(\S)+\.[a-z]{2,}$/gm;

export const validateEmail = (email: string): boolean => Boolean(email?.match(EMAIL_PATTERN));
